import { useEffect } from 'react';

import { useKeyPairStore } from '@/shared/store/decrypted-keypair.store';

import { CHECK_INACTIVITY_INTERVAL } from './constants';
import {
  addUserActivityEventsListeners,
  checkInactivity,
  onRefreshMessage,
  userActivityChannel,
} from './utils';

export const useInactivityTimer = () => {
  const { keyPair } = useKeyPairStore();

  useEffect(() => {
    let interval: NodeJS.Timeout;
    const abortController = new AbortController();

    // Track user activity
    addUserActivityEventsListeners(abortController.signal);

    // Check activity only on authorized tabs
    if (keyPair) {
      // Refresh all tabs at once
      userActivityChannel.addEventListener('message', onRefreshMessage, {
        signal: abortController.signal,
      });

      interval = setInterval(checkInactivity, CHECK_INACTIVITY_INTERVAL);
    }

    return () => {
      abortController.abort();
      clearInterval(interval);
    };
  }, [keyPair]);
};
